module.exports = __webpack_public_path__ + "static/img/question4-1.74fa4c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question4-1.png
// module id = mFx8
// module chunks = 1